import { render, staticRenderFns } from "./ImprintLocationsRow.vue?vue&type=template&id=60bd142f&scoped=true"
import script from "./ImprintLocationsRow.vue?vue&type=script&lang=js"
export * from "./ImprintLocationsRow.vue?vue&type=script&lang=js"
import style0 from "./ImprintLocationsRow.vue?vue&type=style&index=0&id=60bd142f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60bd142f",
  null
  
)

export default component.exports